import {useMutation} from '@apollo/client';
import {DELETE_USER} from "../userTypeDefs";

export const useMutationDeleteUser = (options?: any): any => (
  useMutation(DELETE_USER, options)
);
